import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { NEW_FOCUS_RING_INSET } from 'layout/NewDesignLayout/focusRing';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';
import { BLOCK_CARD_CLASS, BlockTone, DOT_CLASS } from './blocks/Block';
import { BlockId } from './blocks/blockIds';

export interface ContentsEntry {
    id: BlockId;
    number: number;
    title: string;
    summary: string;
    tone: BlockTone;
}

interface Props {
    entries: ContentsEntry[];
    onJump: (id: BlockId) => void;
    onExpandAll: () => void;
    onCollapseAll: () => void;
    className?: string;
}

export function ContentsPanel({ entries, onJump, onExpandAll, onCollapseAll, className }: Props) {
    const linkButton = buttonStyle({ variant: 'text', size: 'extraSmall' });
    return (
        <nav aria-label={t('client-identification.contents')} className={cn(BLOCK_CARD_CLASS, 'p-3', className)}>
            <ul className="m-0 flex list-none flex-col p-0">
                {entries.map((entry) => (
                    <li key={entry.id}>
                        <button
                            type="button"
                            onClick={() => onJump(entry.id)}
                            className={cn(
                                'hover:bg-neutral-tint grid w-full cursor-pointer grid-cols-[8px_minmax(0,1fr)] gap-x-2 rounded-md px-1 py-1.5 text-start',
                                NEW_FOCUS_RING_INSET
                            )}
                        >
                            <span aria-hidden className={cn('mt-1.5 size-2 rounded-full', DOT_CLASS[entry.tone])} />
                            <span className="flex flex-col">
                                <span className="text-body1 font-semibold">
                                    {entry.number} {entry.title}
                                </span>
                                <span className="text-caption text-muted-foreground">{entry.summary}</span>
                            </span>
                        </button>
                    </li>
                ))}
            </ul>
            <div className="mt-2 flex flex-wrap gap-1">
                <Button {...linkButton} onClick={onExpandAll}>
                    {t('client-identification.expand-all')}
                </Button>
                <Button {...linkButton} onClick={onCollapseAll}>
                    {t('client-identification.collapse-all')}
                </Button>
            </div>
        </nav>
    );
}
